<template>
  <div class="collect-select-type">
    <a-form-item :class="{'disabled-input': dis}">
      <a-select
        :default-value="itemData.fieldtype"
        :disabled="!itemData.ischangetype"
        class="collect-item-select"
        @change="handleChange"
      >
        <a-select-option
          v-if="itemData.fieldtype === 'radioinfo_payfor'"
          value="radioinfo_payfor"
          :label="radioType"
        >
          {{ $t('message["150"]') }}
        </a-select-option>
        <a-select-option
          v-if="itemData.fieldtype === 'radioinfo_level'"
          value="radioinfo_level"
          :label="radioType"
        >
          {{ $t('message["150"]') }}
        </a-select-option>
        <a-select-option
          v-if="itemData.fieldtype === 'radioinfo_type'"
          value="radioinfo_type"
          :label="radioType"
        >
          {{ $t('message["150"]') }}
        </a-select-option>
        <a-select-option
          v-if="itemData.fieldtype === 'radioinfo_followup'"
          value="radioinfo_followup"
          :label="radioType"
        >
          {{ $t('message["150"]') }}
        </a-select-option>
        <a-select-option
          v-if="itemData.fieldtype === 'phone'"
          value="phone"
          :label="inputType"
        >
          {{ $t('message["1123"]') }}
        </a-select-option>
        <a-select-option
          v-if="itemData.fieldtype === 'email'"
          value="email"
          :label="inputType"
        >
          {{ $t('message["1123"]') }}
        </a-select-option>
        <a-select-option value="text">
          {{ $t('message["1123"]') }}
        </a-select-option>
        <a-select-option
          value="ip"
          :label="ipAdress"
        >
          {{ ipAdress }}
        </a-select-option>
        <a-select-option value="editor">
          {{ $t('message["328"]') }}
        </a-select-option>
        <a-select-option value="radio">
          {{ $t('message["150"]') }}
        </a-select-option>
        <a-select-option value="checkbox">
          {{ $t('message["263"]') }}
        </a-select-option>
        <a-select-option value="area">
          {{ $t('message["209"]') }}
        </a-select-option>
        <a-select-option value="select_tree">
          {{ $t('message["1142"]') }}
        </a-select-option>
        <a-select-option value="file">
          {{ $t('message["1268"]') }}
        </a-select-option>
        <a-select-option value="tag">
          {{ $t('message["52"]') }}
        </a-select-option>
        <a-select-option value="number">
          {{ $t('message["1140"]') }}
        </a-select-option>
        <a-select-option value="datetime">
          {{ $t('message["1075"]') }}
        </a-select-option>
        <a-select-option value="select">
          {{ $t('message["1297"]') }}
        </a-select-option>
        <!-- <i
          slot="suffixIcon"
          class="iconfont iconicon-test19"
        /> -->
      </a-select>
      <span v-if="itemData.fieldtype === 'radioinfo_payfor'">
        <a
          href="javascript:;"
          @click="setOption"
        >
          <!-- 设置选项 -->
          {{ $t('message["1037"]') }}
        </a>
        <set-option-input
          ref="setoption"
          :item-data="itemData"
          :parent-fieldkey="parentFieldkey"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'radioinfo_level'">
        <a
          href="javascript:;"
          @click="setLevel"
        >
          <!-- 设置分级 -->
          {{ $t('message["1021"]') }}
        </a>
        <set-level
          ref="setlevel"
          :item-data="itemData"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'radioinfo_type'">
        <a
          href="javascript:;"
          @click="setOption"
        >{{ $t('message["1037"]') }}</a>
        <set-option-input
          ref="setoption"
          :parent-fieldkey="parentFieldkey"
          :item-data="itemData"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'radioinfo_followup'">
        <a
          href="javascript:;"
          @click="setOption"
        >{{ $t('message["1037"]') }}</a>
        <set-option-input
          ref="setoption"
          :parent-fieldkey="parentFieldkey"
          :item-data="itemData"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'radio' || (itemData.fieldtype === 'select') ||(itemData.fieldtype === 'checkbox')">
        <a
          href="javascript:;"
          @click="setOption"
        >{{ $t('message["1037"]') }}</a>
        <a-input
          v-decorator="!!itemData.isenable ? decorator : decorator2"
          type="hidden"
        />
        <!-- 设置选项弹窗 -->
        <set-option-input
          ref="setoption"
          :item-data="itemData"
          :clone-data="cloneData"
          :parent-fieldkey="parentFieldkey"
          @getHiddenVal="getHiddenVal"
        />
      </span>
      <span v-if="itemData.fieldtype === 'area'">
        <a
          href="javascript:;"
          @click="getArea"
        >{{ $t('message["1016"]') }}</a>
        <area-dialog
          ref="area"
          :item-data="itemData"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'select_tree'">
        <a
          href="javascript:;"
          @click="getTree"
        >{{ $t('message["1037"]') }}</a>
        <a-input
          v-decorator="(!!itemData.isenable && !itemData.fieldconfig.enableinput) ? decorator : decorator2"
          type="hidden"
        />
        <tree-dialog
          ref="treeDialog"
          :item-data="itemData"
          :clone-data="cloneData"
          @getHiddenVal="getHiddenVal"
        />
      </span>
      <span v-if="itemData.fieldtype === 'datetime'">
        <a
          href="javascript:;"
          @click="setTimeNumber"
        >{{ $t('message["1030"]') }}</a>
        <set-time-number
          ref="settimenumber"
          :item-data="itemData"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'number'">
        <a
          href="javascript:;"
          @click="setTimeNumber"
        >{{ $t('message["1032"]') }}</a>
        <set-time-number
          ref="settimenumber"
          :item-data="itemData"
          :clone-data="cloneData"
        />
      </span>
      <span v-if="itemData.fieldtype === 'phone'">
        <a-checkbox
          :checked="!!itemData.fieldconfig.check"
          class="m-r-4"
          @change="handlePhoneCheck"
        >
          <!-- 格式校验 -->
          {{ $t('message["1974"]') }}
        </a-checkbox>
        <a-popover>
          <template slot="content">
            <p style="width: 370px">
              <!-- 仅支持国内手机号码格式校验，外贸场景下请勿勾选，以免影响录入信息 -->
              {{ $t('message["1975"]') }}
            </p>
          </template>
          <i class="iconfont iconicon-test31 fs-gray" />
        </a-popover>
      </span>
    </a-form-item>
  </div>
</template>
<script>
import AreaDialog from './AreaDialog'
import SetOptionInput from './SetOptionInput'
import SetTimeNumber from './SetTimeNumber'
import SetLevel from './SetLevel'
import treeDialog from '../tree/TreeDialog'
import { cloneDeep } from 'lodash'
export default {
  components: {
    AreaDialog,
    SetOptionInput,
    SetTimeNumber,
    SetLevel,
    treeDialog
  },
  inject: ['myForm'],
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    parentIndex: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    dis: {
      type: Boolean,
      default: false
    },
    parentFieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultvalue: 'radio',
      cloneData: {},
      decorator: [
        `inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`,
        {
          rules: [{ required: true, message: this.$t('message["1038"]') }],
          initialValue: this.itemData.options.join(',')
        }
      ],
      decorator2: [
        `inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`,
        {
          initialValue: this.itemData.options.join(',')
        }
      ]
    }
  },
  computed: {
    radioType () {
      return this.$t('message["150"]')
    },
    inputType () {
      return this.$t('message["1123"]')
    },
    ipAdress () {
      return this.$t('message["1714"]')
    }
  },
  mounted () {
    // const val = this.itemData.fieldtype
    // if (val === 'select' || val === 'radio' || val === 'checkbox') {
    //   this.setTipType(val)
    // }
  },
  methods: {
    handleChange (val) {
      this.itemData.fieldtype = val
      if (val === 'datetime' && (!this.itemData.fieldconfig.formatdatetime)) {
        this.$set(this.itemData.fieldconfig, 'formatdatetime', 1)
      }
      if (val === 'number' && (!this.itemData.fieldconfig.isallowminus)) {
        this.$set(this.itemData.fieldconfig, 'isallowminus', 0)
        this.$set(this.itemData.fieldconfig, 'isallowdecimals', 0)
      }
      if (val === 'area' && (!this.itemData.options2)) {
        this.$set(this.itemData, 'options2', [])
      }
      this.$set(this.itemData, 'options', [])
      if (val === 'select' || val === 'radio' || val === 'checkbox' || val === 'select_tree') {
        this.$nextTick(() => {
          this.myForm.form.setFieldsValue({
            [`inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`]: ''
          })
          // this.myForm.form.validateFields([`input_${this.parentIndex}_${this.itemData.id || this.itemData._id}`])
        })
      }
    },
    setTipType (val) {
      if (val === 'checkbox') {
        this.tipType = this.$t('message["263"]')
      } else if (val === 'radio') {
        this.tipType = this.$t('message["263"]')
      } else if (val === 'select') {
        this.tipType = this.$t('message["1297"]')
      }
    },
    getArea () {
      this.cloneData = cloneDeep(this.itemData)
      if (this.itemData.fieldconfig.enableforeign !== 0 && (this.itemData.fieldconfig.enableforeign !== 1)) {
        this.itemData.fieldconfig.enableforeign = 0
      }
      this.$refs.area.changeVisible(true)
    },
    setOption () {
      this.cloneData = cloneDeep(this.itemData)
      this.$refs.setoption.changeVisible(true)
    },
    setTimeNumber () {
      this.cloneData = cloneDeep(this.itemData)
      if (this.itemData.fieldtype === 'number') {
        if (this.itemData.fieldconfig.isallowminus !== 1 && (this.itemData.fieldconfig.isallowminus !== 0)) {
          this.itemData.fieldconfig.isallowminus = 0
          this.itemData.fieldconfig.isallowdecimals = 0
        }
      } else {
        if (!this.itemData.fieldconfig.formatdatetime) {
          this.itemData.fieldconfig.formatdatetime = 1
        }
      }

      this.$refs.settimenumber.changeVisible(true)
    },
    handlePhoneCheck (e) {
      const val = e.target.checked ? 1 : 0
      this.itemData.fieldconfig.check = val
    },
    setLevel () {
      this.cloneData = cloneDeep(this.itemData)
      this.$refs.setlevel.changeVisible(true)
    },
    getTree () {
      this.cloneData = cloneDeep(this.itemData)
      this.$refs.treeDialog.changeVisible(true)
    },
    getHiddenVal (val) {
      this.myForm.form.setFieldsValue({
        [`inputHidden_${this.parentIndex}_${this.index}_${this.itemData.id || this.itemData._id}`]: val
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .collect-select-type::v-deep {
    display: inline;
    .collect-item-select {
      margin-right: 16px;
      width: 240px;
    }
    .disabled-input  .has-error {
      .ant-select-selection {
        border-color: #d6d6d6;
      }
      .ant-select-arrow-icon {
        color: rgba(0, 0, 0, 0.25)
      }
      .ant-form-explain {
        display: none;
      }
    }
  }
</style>
